import { Button } from '@hashicorp/react-mds/src/components/button'
import Image from 'next/legacy/image'
import s from './style.module.css'

export interface HeroProps {
	eyebrow: string
	heading: string
	description: string | React.ReactNode
	cta?: {
		text: string
		url: string
	}
	image: {
		src: string
		alt: string
		width?: number
		height?: number
	}
}

export default function Hero({
	eyebrow,
	heading,
	description,
	cta,
	image,
}: HeroProps) {
	return (
		<div className={s.hero}>
			<div className={s.backgroundWrap}>
				<div className={s.contentContainer}>
					<h1 className={s.eyebrow}>{eyebrow}</h1>
					<div className={s.copySplit}>
						<div className={s.copy}>
							<p className={s.heading}>{heading}</p>
							{typeof description === 'string' ? (
								<div
									className={s.description}
									dangerouslySetInnerHTML={{
										__html: description,
									}}
								/>
							) : (
								<div className={s.description}>{description}</div>
							)}
							{cta && <Button title={cta.text} url={cta.url} />}
						</div>
						<div className={s.image}>
							<Image
								src={image.src}
								alt={image.alt}
								width={image.width}
								height={image.height}
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
